import React, { useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { WhatsApp } from '@mui/icons-material';
import '../sass/hablamos_whatsapp.scss';

type Props = {
    telefono: string;
    mensaje?: string;
    /** ms antes de mostrar el texto por primera vez (deja cargar la pagina) */
    retardoInicial?: number;
    /** ms que el texto permanece visible */
    tiempoVisible?: number;
    /** ms que el texto permanece oculto */
    tiempoOculto?: number;
};

const HablamosWhatsapp = ({
    telefono,
    mensaje,
    retardoInicial = 1500,
    tiempoVisible = 4000,
    tiempoOculto = 4000,
}: Props) => {
    const [mostrarTexto, setMostrarTexto] = useState<boolean>(false);
    const [hover, setHover] = useState<boolean>(false);
    const [ciclo, setCiclo] = useState<number>(0);
    const [primeraVez, setPrimeraVez] = useState<boolean>(true);

    useEffect(() => {
        if (hover) return;
        let delay: number;
        if (primeraVez) {
            delay = retardoInicial;
        } else {
            delay = mostrarTexto ? tiempoVisible : tiempoOculto;
        }
        const timer = setTimeout(() => {
            setPrimeraVez(false);
            setMostrarTexto(primeraVez ? true : !mostrarTexto);
        }, delay);
        return () => clearTimeout(timer);
    }, [mostrarTexto, hover, ciclo, primeraVez, retardoInicial, tiempoVisible, tiempoOculto]);

    const onMouseEnter = () => {
        setHover(true);
        setPrimeraVez(false);
        setMostrarTexto(true);
    };

    const onMouseLeave = () => {
        setHover(false);
        setMostrarTexto(true);
        setCiclo((c) => c + 1);
    };

    if (!telefono) return null;

    const numero = telefono.replace(/\D/g, '');
    const texto = mensaje ? encodeURIComponent(mensaje) : '';
    const href = isMobile
        ? `https://wa.me/${numero}${texto ? `?text=${texto}` : ''}`
        : `https://web.whatsapp.com/send?phone=${numero}${texto ? `&text=${texto}` : ''}`;

    return (
        <a
            href={href}
            target="_blank"
            rel="noreferrer"
            className="hablamos-whatsapp"
            aria-label="Escribinos por WhatsApp"
            title="Escribinos por WhatsApp"
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            onFocus={onMouseEnter}
            onBlur={onMouseLeave}
        >
            <span
                className={`hablamos-whatsapp__texto ${mostrarTexto ? 'visible' : 'oculto'}`}
                aria-hidden={!mostrarTexto}
            >
                ¿Hablamos?
            </span>
            <span className="hablamos-whatsapp__icono">
                <WhatsApp fontSize="inherit" />
            </span>
        </a>
    );
};

export default HablamosWhatsapp;
